import { Inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { ProjectConfigService } from './project-config.service';
import { AppConfig } from '../interfaces/app-config';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class PageService {
    private config: AppConfig;

    private titleSubject = new BehaviorSubject<string>('Cargando...');
    title$ = this.titleSubject.asObservable();
    
    private breadcrumbsSubject = new BehaviorSubject<{url: string, title: string}[]>([]);
    breadcrumbs$ = this.breadcrumbsSubject.asObservable();

    constructor(
        private configService: ProjectConfigService,
        @Inject(DOCUMENT) private document: Document,
        private titleService: Title,
        private metaService: Meta
    ) {
        this.config = this.configService.getConfig();
    }

    set title(title: string | undefined) {
        if (title) {
            this.titleSubject.next(title);
            this.titleService.setTitle(`${title} | ${this.config.metadata.title}`);
        } else {
            this.titleSubject.next(this.config.metadata.title);
            this.titleService.setTitle(this.config.metadata.title);
        }
    }

    get title(): string {
        return this.titleSubject.value;
    }

    set breadcrumbs(breadcrumbs: {url: string, title: string}[]) {
        this.breadcrumbsSubject.next(breadcrumbs);
    }

    get breadcrumbs(): {url: string, title: string}[] {
        return this.breadcrumbsSubject.value;
    }

    updateMetadata(config: {
        title?: string;
        description?: string;
        keywords?: string;
        favicon?: string;
    }): void {
        // Actualizar título
        if (config.title) {
            this.titleService.setTitle(config.title);
        }

        // Actualizar descripción
        if (config.description) {
            this.updateMetaTag('description', config.description);
        }

        // Actualizar keywords
        if (config.keywords) {
            this.updateMetaTag('keywords', config.keywords);
        }

        // Actualizar favicon
        if (config.favicon) {
            this.updateFavicon(config.favicon);
        }
    }

    private updateMetaTag(name: string, content: string): void {
        // Actualizar o crear la etiqueta meta
        if (this.metaService.getTag(`name='${name}'`)) {
            this.metaService.updateTag({ name, content });
        } else {
            this.metaService.addTag({ name, content });
        }
    }

    private updateFavicon(href: string): void {
        let linkElement = this.document.querySelector("link[rel~='icon']") as HTMLLinkElement;
        
        if (!linkElement) {
            linkElement = this.document.createElement('link');
            linkElement.rel = 'icon';
            this.document.head.appendChild(linkElement);
        }
        
        linkElement.href = href;
    }
}
